<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px"
     class="snackbar-container"
     [class]="style">
    <div class="t4 c-primary-gray-900 pre-line p-12">
        @if (data.messageHtml) {
            <span [innerHTML]="data.messageHtml | translate:data.translationParams | safeHtml"
                  [commonsClickById]="data.commonsClickById || {}"></span>
        } @else {
            {{ data.message | translate:data.translationParams }}
        }
    </div>
    @if (data.isInfinite) {
        <ui-kit-svg name="ic_close_circle" class="i-16 c-secondary-red-900 pointer" (click)="snackbarService.dismiss()"/>
    }
</div>
